import React, { useContext, useCallback } from 'react';
import { AnalyticContext } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-recent/src/common/controllers/analytic-context/index.tsx';
import { LinkMenuItem } from '@atlaskit/side-nav-items/link-menu-item';
import type { JiraRecentOLFItem } from './JiraRecentOLFItem.types.tsx';

export function RecentMenuLinkItemAdaptor(params: JiraRecentOLFItem): React.JSX.Element {
	const { href, elemBefore, primaryLabel, secondaryLabel, tertiaryLabel, analytics, onClick } =
		params;

	const description = secondaryLabel
		? `${secondaryLabel}${tertiaryLabel ? ` • ${tertiaryLabel}` : ''}`
		: '';

	const { fireUIAnalyticForRecentItems } = useContext(AnalyticContext);
	const handleClick = useCallback(
		(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
			fireUIAnalyticForRecentItems(analytics);
			// It's important to call onClick so that the flyout closes when the menu item is clicked
			onClick?.(event);
		},
		[analytics, fireUIAnalyticForRecentItems, onClick],
	);

	return (
		<LinkMenuItem
			elemBefore={elemBefore}
			href={href || ''}
			description={description}
			onClick={handleClick}
		>
			{primaryLabel}
		</LinkMenuItem>
	);
}
